import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  darkTheme: boolean = false;
  largeTheme: boolean = false;
  bannerMessage: string = `<b>Scheduled maintenance:</b> This site will be unavailable from 17:00 to 21:00 on Thursday 26th March 2026. We apologise for any inconvenience.`;
}
